export default __webpack_public_path__ + "static/media/0110.15817385.jpg";